module.exports = __webpack_public_path__ + "static/media/ucon13.2e9995dc.JPG";